import api from "@/services/api.service";
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'add',
  components: {},
  props: [],
  data () {
    return {
      caption:"User Add",
      campaigns:[],
      formField:{first_name:'',last_name:'',role_id:'',email:'',phone:'',password:''},
      submitStatus: null,
      roles:[],
      permission_add: false,
      superAdmin: false          
    }
  },
  computed: {

  },
  mounted () {

  },
  validations: {
    formField: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      role_id:{
        required
      },
      email:{
        required,email
      },
      phone:{
        required, maxLength: maxLength(14)
      },
      password:{
        required,minLength: minLength(6) 
      }
    }
  },
  async created(){ 
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_user") == true){  
              this.getRoles(); 
              // this.getTags();    
              this.permission_add = permissions.includes("add_user");
            }else if(response.data[0].role == 'super_admin'){
              this.getRoles(); 
              // this.getTags();   
              this.superAdmin = true;
            }else if(permissions.includes("list_user") == true || permissions.includes("add_user") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'User List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }  
  },
  methods: {
    acceptNumber(e) {       
      if(e){
        let char = String.fromCharCode(e.keyCode);
        
        if(/^[A-Za-z]+$/.test(char)) {
          e.preventDefault(); }
        else {
        var x = this.formField.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,5})/);
        this.formField.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');        
        }
      }
    },
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },
    async getRoles() {
      let response = await api.post("role/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.data.forEach(
          function(e) {            
            this.roles.push({ value: e.id, text: e.role });
          }.bind(this)
          );
      }
    },      
    async save(){
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = true
      } else{
        let response = await api.post('admin/users/add', this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if(response.status=='success'){
          this.makeToast(response.message,'Success','success');
          this.$router.push({name:"User List"})
        }else{
          for(var error in response.errors){
            this.makeToast(response.errors[error],'Alert','danger');
          }
        }
      }
    }
  }
}


